import { Link } from "react-router-dom";
import { bookHref } from "@/lib/cta";
import { CalendarCheck, ArrowUpRight } from "lucide-react";

// Primary conversion action — consistent wording site-wide.
export function BookButton({ reason, size = "md", className = "", testid = "book-consultation-btn" }) {
  const pad = size === "lg" ? "px-8 py-4" : "px-6 py-3.5";
  return (
    <Link
      to={bookHref(reason)}
      data-testid={testid}
      className={`inline-flex items-center justify-center gap-2 font-sans text-xs uppercase tracking-[0.2em] bg-gold text-ink ${pad} hover:bg-goldhover transition-colors duration-300 ${className}`}
    >
      <CalendarCheck size={15} /> Book a Consultation
    </Link>
  );
}

// Secondary action — service-specific.
export function SecondaryButton({ to, label, size = "md", className = "", testid, arrow = true }) {
  const pad = size === "lg" ? "px-8 py-4" : "px-6 py-3.5";
  return (
    <Link
      to={to}
      data-testid={testid}
      className={`group inline-flex items-center justify-center gap-2 font-sans text-xs uppercase tracking-[0.2em] border border-white/20 text-bone ${pad} hover:border-gold hover:text-gold transition-colors duration-300 ${className}`}
    >
      {label} {arrow && <ArrowUpRight size={15} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />}
    </Link>
  );
}

// A paired CTA: secondary (service) + primary (book), side-by-side on desktop.
export function CtaPair({ serviceTo, serviceLabel, reason, serviceTestid, bookTestid, className = "" }) {
  return (
    <div className={`flex flex-col sm:flex-row gap-3 ${className}`}>
      <SecondaryButton to={serviceTo} label={serviceLabel} testid={serviceTestid} />
      <BookButton reason={reason} testid={bookTestid} />
    </div>
  );
}
